import {
  captureNavigationStateFromDocument,
  NAVIGATION_PAGE,
  readNavigationState,
  writeNavigationState
} from './navigation-state.js';

function getCollectionTitle() {
  var titleNode =
    document.querySelector('.flex-collection-header__title') ||
    document.querySelector('.new-collection-header__title') ||
    document.querySelector('.collection-header__title') ||
    document.querySelector('h1');
  return titleNode ? titleNode.textContent.trim() : '';
}

function isBrandCollectionHandle(handle) {
  return /^brands-/i.test(String(handle || '').trim());
}

function getCollectionsMeta(nav) {
  if (!nav) return null;

  return {
    collectionsUrl: nav.getAttribute('data-collections-url') || '/collections',
    collectionsLabel: nav.getAttribute('data-collections-label') || 'Collections'
  };
}

function applyProductBreadcrumbFromState() {
  if (!document.body.classList.contains('template-product')) return;

  var stored = readNavigationState();
  if (
    !stored ||
    stored.type === NAVIGATION_PAGE.HOME ||
    stored.type === NAVIGATION_PAGE.SEARCH
  ) {
    return;
  }

  var navs = document.querySelectorAll(
    '.product-information .breadcrumbs[data-collections-url]'
  );

  navs.forEach(function(nav) {
    var middleLink = nav.querySelector('.breadcrumb-middle-link');
    if (!middleLink) return;

    var meta = getCollectionsMeta(nav);

    if (stored.type === NAVIGATION_PAGE.COLLECTIONS) {
      middleLink.href = stored.url || meta.collectionsUrl;
      middleLink.textContent = stored.title || meta.collectionsLabel;
      return;
    }

    if (stored.type === NAVIGATION_PAGE.COLLECTION && stored.url) {
      if (isBrandCollectionHandle(stored.handle)) return;
      middleLink.href = stored.url;
      middleLink.textContent = stored.title || stored.handle || middleLink.textContent;
    }
  });
}

function applyProductBackFromState() {
  if (!document.body.classList.contains('template-product')) return;

  var stored = readNavigationState();
  if (
    !stored ||
    stored.type === NAVIGATION_PAGE.HOME ||
    stored.type === NAVIGATION_PAGE.SEARCH
  ) {
    return;
  }

  var backLink = document.querySelector('.product-information__media-action--back');
  if (!backLink) return;

  if (stored.type === NAVIGATION_PAGE.COLLECTIONS) {
    backLink.href = stored.url || '/collections';
    return;
  }

  if (stored.type === NAVIGATION_PAGE.COLLECTION && stored.url) {
    if (isBrandCollectionHandle(stored.handle)) return;
    backLink.href = stored.url;
  }
}

function saveNavigationState() {
  var payload = captureNavigationStateFromDocument(getCollectionTitle);
  if (!payload) return;

  if (payload.type === NAVIGATION_PAGE.COLLECTIONS) {
    var nav = document.querySelector('.collection-breadcrumbs[data-collections-url]');
    var meta = getCollectionsMeta(nav);
    if (meta) {
      payload.url = meta.collectionsUrl;
      payload.title = meta.collectionsLabel;
    }
  }

  writeNavigationState(payload);
}

function init() {
  applyProductBreadcrumbFromState();
  applyProductBackFromState();
  saveNavigationState();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}

window.addEventListener('pageshow', init);

document.addEventListener('shopify:section:load', init);
